import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  popover: {
    '& .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation8.MuiPopover-paper':
      {
        borderRadius: theme.new.shape.borderRadius.small,
      },
  },
  stableAnchorPopper: {
    zIndex: theme.zIndex.modal,
  },
  stableAnchorPaper: {
    borderRadius: theme.new.shape.borderRadius.small,
  },
  titleContainer: {
    padding: theme.spacing(2),
    borderBlockEnd: `1px solid ${theme.new.color.border}`,
  },
  actionButtonsContainer: {
    padding: theme.spacing(2),
    borderBlockStart: `1px solid ${theme.new.color.border}`,
    marginTop: '1px',
  },
  actionButtonsContainerSpaceBetween: {
    padding: theme.spacing(2),
    borderBlockStart: `1px solid ${theme.new.color.border}`,
    marginTop: '1px',
    '& > div': {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
  },
}));

export default useStyles;
